import React from 'react';

const Hero = () => {
  return (
    <div className="max-w-5xl mx-auto px-6">
    <div className="text-center mb-12">
      <h2 className="text-5xl font-bold uppercase mb-4 text-brandOrange">The Science of Food Packaging</h2>
      <p className="text-xl text-gray-700">
        Innovative films, containers, sealing machines, and food-science powered solutions for the food industry.
      </p>
    </div>
  </div>
  );
};

export default Hero;